import { isBoolean, isString } from '../fold-helpers';
import { createWidgetNormalizer } from '../create-widget-normalizer';

/**
 * Lifts a flat top-level field into `data` — same "model sent `{ columnId, isIndent }` instead of
 * nesting it" miss indent's normalizer exists for, generalized to every field this widget has. See
 * `navigation-widget-args.normalization.ts` for the pattern this mirrors.
 */
const accordionNormalizer = createWidgetNormalizer({
    rules: [
        { target: 'accordionList', accepts: Array.isArray },
        { target: 'horizontalAlign', accepts: isString },
        { target: 'iconType', accepts: isString },
        { target: 'isIndent', accepts: isBoolean },
        { target: 'indentColor', accepts: isString },
        { target: 'iconColor', accepts: isString },
        { target: 'isAutoCollapse', accepts: isBoolean },
        { target: 'isSynchronizeStyle', accepts: isBoolean },
        { target: 'hideOnDesktop', accepts: isBoolean },
        { target: 'hideOnTablet', accepts: isBoolean },
        { target: 'hideOnMobile', accepts: isBoolean },
    ],
    optionalData: true,
});

export function normalizeAccordionWidgetArgs(raw: unknown): unknown {
    return accordionNormalizer.normalize(raw);
}
